import { Instance } from 'mobx-state-tree';
import { BillingPlanUpdatedDtoModelBase } from './BillingPlanUpdatedDtoModel.base';

/* The TypeScript type of an instance of BillingPlanUpdatedDtoModel */
export interface BillingPlanUpdatedDtoModelType extends Instance<typeof BillingPlanUpdatedDtoModel.Type> {}

/* A graphql query fragment builders for BillingPlanUpdatedDtoModel */
export { selectFromBillingPlanUpdatedDto, billingPlanUpdatedDtoModelPrimitives, BillingPlanUpdatedDtoModelSelector } from './BillingPlanUpdatedDtoModel.base';

/**
 * BillingPlanUpdatedDtoModel
 */
export const BillingPlanUpdatedDtoModel = BillingPlanUpdatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
